'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  header: '',
  item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox" class="{{cssClasses.checkbox}}" value="{{name}}" {{#isRefined}}checked{{/isRefined}} />{{name}}\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
  footer: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/instantsearch.js/dist-es5-module/src/widgets/refinement-list/defaultTemplates.js
// module id = 788
// module chunks = 0